import { createSlice } from "@reduxjs/toolkit";
import {
  getNavigationVisibility,
  saveNavigationVisibility,
} from "./navigationVisibilityThunk";

const initialState = {
  navigationData: [],
  loading: false,
  saveLoading: false,
  error: null,
};

const navigationVisibilitySlice = createSlice({
  name: "navigationVisibility",
  initialState,

  reducers: {
    clearNavigationVisibilityState: (state) => {
      state.error = null;
      state.navigationData = [];
    },
  },

  extraReducers: (builder) => {
    builder

      // GET NAVIGATION VISIBILITY
      .addCase(getNavigationVisibility.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getNavigationVisibility.fulfilled, (state, action) => {
        state.loading = false;
        state.navigationData = action.payload;
      })

      .addCase(getNavigationVisibility.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(saveNavigationVisibility.pending, (state) => {
        state.saveLoading = true;
        state.error = null;
      })

      .addCase(saveNavigationVisibility.fulfilled, (state) => {
        state.saveLoading = false;
      })

      .addCase(saveNavigationVisibility.rejected, (state, action) => {
        state.saveLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearNavigationVisibilityState } =
  navigationVisibilitySlice.actions;

export default navigationVisibilitySlice.reducer;
